import { render } from "./Inventory_Company_Selector.vue?vue&type=template&id=2de4ccd6&scoped=true&ts=true"
import script from "./Inventory_Company_Selector.vue?vue&type=script&lang=ts"
export * from "./Inventory_Company_Selector.vue?vue&type=script&lang=ts"

import "./Inventory_Company_Selector.vue?vue&type=style&index=0&id=2de4ccd6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de4ccd6"]])

export default __exports__